import React from 'react';
import { Col, Row } from 'reactstrap';

import {
  associatedBrandShape,
  campaignLineTextBundleShape,
} from '../../prop-types';
import { replacedBrandPlaceholders } from '../utils';

function PreviewCopyBundle({ bundle, brand }) {
  const previewableBundleItem =
    bundle.campaignLineTextBundleItems.find(
      item => item.country === 'DE' && item.language === 'EN',
    ) || {};

  return (
    <>
      <p className="mb-4">
        This is a preview for the copy text in English for Germany.
      </p>
      <Row className="mb-2">
        <Col sm={2} className="font-weight-semi-bold">
          Headline
        </Col>
        <Col data-field-name="subTitle">
          {replacedBrandPlaceholders(previewableBundleItem.subTitle, brand)}
        </Col>
      </Row>
      <Row className="mb-2">
        <Col sm={2} className="font-weight-semi-bold">
          Subline
        </Col>
        <Col data-field-name="title">
          {replacedBrandPlaceholders(previewableBundleItem.title, brand)}
        </Col>
      </Row>
      <Row className="mb-2">
        <Col sm={2} className="font-weight-semi-bold">
          CTA
        </Col>
        <Col data-field-name="cta">
          {replacedBrandPlaceholders(previewableBundleItem.cta, brand)}
        </Col>
      </Row>
    </>
  );
}

PreviewCopyBundle.propTypes = {
  bundle: campaignLineTextBundleShape.isRequired,
  brand: associatedBrandShape.isRequired,
};

export default PreviewCopyBundle;
